(function () {
  'use strict';
  if (window.LamedaDateWindows) {
    window.LamedaDateWindows.apply(document);
    return;
  }

  var TIME_ZONE = 'America/Los_Angeles';
  var EVENT_START = 20261001000000;
  var EVENT_END = 20261101000000;
  var SUPPORT_END = 20261008000000;

  function zonedKey(date) {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: TIME_ZONE,
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    var values = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = part.value;
    });
    return Number(values.year + values.month + values.day + values.hour + values.minute + values.second);
  }

  function evaluate(date) {
    var key = zonedKey(date || new Date());
    return {
      timezone: TIME_ZONE,
      key: key,
      event: key < EVENT_START ? 'upcoming' : key < EVENT_END ? 'live' : 'ended',
      support: key < EVENT_START ? 'upcoming' : key < SUPPORT_END ? 'limited' : 'resumed'
    };
  }

  function showState(root, state) {
    root.removeAttribute('hidden');
    root.setAttribute('data-lameda-current-state', state);
    Array.prototype.forEach.call(root.querySelectorAll('[data-lameda-state]'), function (node) {
      node.hidden = node.getAttribute('data-lameda-state') !== state;
    });
  }

  function apply(scope, date) {
    var target = scope || document;
    var state = evaluate(date);
    Array.prototype.forEach.call(target.querySelectorAll('[data-lameda-limited-support]'), function (node) {
      node.hidden = state.support !== 'limited';
      node.setAttribute('data-lameda-current-state', state.support);
    });
    Array.prototype.forEach.call(target.querySelectorAll('[data-lameda-community-service]'), function (node) {
      showState(node, state.support === 'limited' ? 'during' : state.support);
    });
    Array.prototype.forEach.call(target.querySelectorAll('[data-lameda-event-announcement]'), function (node) {
      if (state.event === 'ended') {
        node.hidden = true;
        node.setAttribute('data-lameda-current-state', 'ended');
      } else {
        showState(node, state.event);
      }
    });
    document.documentElement.setAttribute('data-lameda-event-state', state.event);
    document.documentElement.setAttribute('data-lameda-support-state', state.support);
    document.dispatchEvent(new CustomEvent('lameda:date-windows-ready', { detail: state }));
    return state;
  }

  window.LamedaDateWindows = { evaluate: evaluate, apply: apply, timezone: TIME_ZONE };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { apply(document); });
  } else {
    apply(document);
  }
})();
